// @flow
import React from 'react';
import { Row, Col } from 'reactstrap';
import classNames from 'classnames';

import './Success.scss';
import logo from 'components/pages/ConfirmationPage/components/Success/icons8-car-service-50.png';

// Utils
import { formatTime } from 'utils/date';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

const ns = 'self-checkin-success';
const md = 'middle';

type State = {
  animationFlag: boolean
};

export type Props = {
  intl: IntlShape,
  date: Object,
  needServiceAdvisor: boolean,
  isDealerOpen: boolean
};

class Success extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      animationFlag: false
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      animationFlag: true
    });
  }

  render() {
    // TODO: remove default message when localizations are done
    const { isDealerOpen } = this.props;
    const classProps = classNames(ns, {
      'animation-active': this.state.animationFlag
    });
    const { date, intl, needServiceAdvisor } = this.props;

    return (
      <Row className={classProps}>
        <Col xs={12}>
          <img src={logo} alt="" />
        </Col>
        <Col xs={12} className={`${ns}__${md}--title`}>
          {intl.formatMessage({
            id: 'c8.self.check.in.confirmation.page.checked.in.complete',
            defaultMessage: 'Check in complete'
          })}
        </Col>
        {needServiceAdvisor === false && (
          <Col xs={12} className={`${ns}__${md}--message`}>
            {intl.formatMessage({
              id: 'c8.self.check.in.confirmation.page.you.are.all.set',
              defaultMessage: 'You are all set'
            })}
          </Col>
        )}
        {needServiceAdvisor === true &&
          isDealerOpen && (
            <Col xs={12} className={`${ns}__${md}--message`}>
              {intl.formatMessage({
                id: 'c8.self.check.in.confirmation.page.service.wait.advisor',
                defaultMessage: 'Wait to speak to an advisor'
              })}
            </Col>
          )}
        {date && (
          <React.Fragment>
            <Col xs={12} className={`${ns}__${md}--time`}>
              {formatTime(date, intl, false, false)}
            </Col>
            <Col xs={12} className={`${ns}__${md}--date`}>
              {intl.formatDate(date, {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
              })}
            </Col>
          </React.Fragment>
        )}
      </Row>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/Success/Success.js